import ListTable from './list-table';

const List = ({ stratigraphyLexicons, updateStratigraphyLexicon, addStratigraphyLexicon, deleteAddingRow, deleteStratigraphyLexicon }: any) => {

    if (!stratigraphyLexicons || !stratigraphyLexicons.length) {
        return null;
    }
    
    const firstHalfLength = Math.ceil(stratigraphyLexicons.length / 2);    
    const firstHalf = stratigraphyLexicons.slice(0, firstHalfLength);
    const secondHalf = stratigraphyLexicons.slice(firstHalfLength);

    return (
            <div className="columns">
              <div className="column">   
                <ListTable stratigraphyLexicons={firstHalf} 
                           updateStratigraphyLexicon={updateStratigraphyLexicon} 
                           addStratigraphyLexicon={addStratigraphyLexicon} 
                           deleteAddingRow={deleteAddingRow} 
                           deleteStratigraphyLexicon={deleteStratigraphyLexicon}
                           allStratigraphyLexicons={stratigraphyLexicons} />
              </div>
              <div className="column">                    
                <ListTable stratigraphyLexicons={secondHalf} 
                           updateStratigraphyLexicon={updateStratigraphyLexicon} 
                           addStratigraphyLexicon={addStratigraphyLexicon} 
                           deleteAddingRow={deleteAddingRow} 
                           deleteStratigraphyLexicon={deleteStratigraphyLexicon}
                           allStratigraphyLexicons={stratigraphyLexicons} />
              </div>
            </div>
    )    
};

export default List;